import { render } from "./LbrxLanguagePopup.vue?vue&type=template&id=616a2f50&scoped=true"
import script from "./LbrxLanguagePopup.vue?vue&type=script&lang=js"
export * from "./LbrxLanguagePopup.vue?vue&type=script&lang=js"

import "./LbrxLanguagePopup.vue?vue&type=style&index=0&id=616a2f50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616a2f50"]])

export default __exports__